import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";

const flexRowCenter = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

export const StyledPaper = styled(Paper)(({ theme }) => ({
  ...flexRowCenter,
  width: "100%",
  height: "50px",
  marginBottom: theme.spacing(2),
  marginTop: theme.spacing(2),
  padding: theme.spacing(2),
  backgroundColor: "#1A2027",
  color: "whitesmoke",
  overflow: "hidden",
}));
